import React, { useEffect, useState } from "react";
import InnerTitle2 from "../../components/InnerTitle2";
import { faqList } from "../../services/cms.service";
import { type } from "@testing-library/user-event/dist/cjs/utility/type.js";
import { FAQTYPES } from "../../../../utils/Constants";

// --- FaqItem Component ---
const FaqItem = ({
  question,
  answer,
  id,
  isOpen,
  onToggle,
  isHighlight = false,
}) => {
  const headerClasses = `
    flex justify-between items-center w-full p-[20px] cursor-pointer transition-all duration-300
    ${isOpen ? "bg-primary-50" : "bg-white"}
  `;

  const titleClasses = `
    headings-h4 transition-colors duration-300
    ${isOpen ? "text-primary-400" : "text-zinc-800"}
  `;

  const iconClasses = `
    w-5 h-5 transition-transform duration-300
    ${isOpen ? "transform rotate-180 text-primary-400" : "text-zinc-500"}
  `;

  const contentClasses = `
    overflow-hidden transition-all duration-300 ease-in-out
    ${isOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"}
  `;

  return (
    <div
      className={`mb-4 overflow-hidden rounded-[10px] shadow-[0px_2px_24px_0px_rgba(0,0,0,0.05)] border border-zinc-100 bg-white`}
    >
      {/* Header */}
      <div
        className={headerClasses}
        role="button"
        aria-expanded={isOpen}
        onClick={() => onToggle(id)}
      >
        <h3 className={titleClasses}>{question}</h3>

        {/* Chevron Icon */}
        <svg
          className={iconClasses}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      {/* Content */}
      <div className={contentClasses} role="region">
        {isOpen && (
          <div className="p-[15px]">
            <p className="body-lg text-gray-400 !leading-relaxed">{answer}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// --- FaqList Component ---
const FaqList = () => {
  const [openItemId, setOpenItemId] = useState(2);
  const [faqDataList , setFaqDataList] = useState([]);

  useEffect(()=>{
    faqList({ type: FAQTYPES.WEBSITE})
      .then((response) => {
        // console.log(response.data.list);
        setFaqDataList(response.data.list);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [])



  const handleToggle = (id) => {
    setOpenItemId(openItemId === id ? null : id);
  };

  return (
    <div className="">
{faqDataList.map((item, index) => (
  <FaqItem 
    key={item.id || index} 
    id={item.id || index} 
    question={item.question} 
    answer={item.answer} 
    isOpen={(item.id || index) === openItemId} 
    onToggle={handleToggle} 
  />
))}
    </div>
  );
};

// --- Main Faq Component ---
function Faq() {
  return (
    <div className="faq-bg py-8 pt-0">
      <InnerTitle2 title="FAQ" />
      <div className="faq-content-bg py-8 pb-0">
        <div className="container">
          <FaqList />
        </div>
      </div>
    </div>
  );
}

export default Faq;
